import {richText2react} from "../../utils";

export function richText(v: any[]|undefined, p: {[key: string]: any}, k: string) {
    p[k] = richText2react(v);
}

export default richText
